import React from "react";
import { Badge, Button, Spinner } from "react-bootstrap";

// The selected-address summary and its Change Address button, shared by every screen that picks a
// delivery address through AddressSelectionModal. Extracted from the place-order form so a second
// screen renders the same card instead of copying its markup and drifting from it.
function AddressSummaryCard({
  label,
  address,
  isLoading,
  onChangeClick,
  changeDisabled = false,
  // Replaces the address body when the card cannot show one at all (e.g. no customer resolved).
  error = null,
  children = null,
}) {
  return (
    <div
      className="mb-2 p-2 rounded"
      style={{ border: "1px solid #D9D9D9", backgroundColor: "#fafafa" }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-semibold" style={{ fontSize: 13 }}>
          {label}
        </span>
        <Button
          size="sm"
          variant="outline-primary"
          onClick={onChangeClick}
          disabled={changeDisabled}
          style={{ fontSize: 12 }}
        >
          {address ? "Change Address" : "Select Address"}
        </Button>
      </div>

      {error ? (
        <p className="text-danger mb-0 mt-1" style={{ fontSize: 12 }}>
          {error}
        </p>
      ) : isLoading ? (
        <div className="text-center py-2">
          <Spinner size="sm" />
        </div>
      ) : address ? (
        <div className="mt-1" style={{ fontSize: 13 }}>
          <div className="d-flex align-items-center gap-1">
            <span className="fw-medium">{address.address1}</span>
            {address.is_default && (
              <Badge bg="primary" style={{ fontSize: 9 }}>Default</Badge>
            )}
          </div>
          {address.address2 && (
            <div className="text-muted">{address.address2}</div>
          )}
          <div className="text-muted">
            {address.city}, {address.province} - {address.zip}, {address.country}
          </div>
        </div>
      ) : (
        <p className="text-danger mb-0 mt-1" style={{ fontSize: 12 }}>
          No address selected. Click "Select Address" to choose one.
        </p>
      )}

      {children}
    </div>
  );
}

export default AddressSummaryCard;
